import React from "react";
import { useTranslation } from "react-i18next";
import { v4 as guid } from "uuid";
import ButtonBase from "../../../../common/components/form/ButtonBase.jsx";
import ButtonIconTrash from "../../../../common/components/form/ButtonIconTrash.jsx";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";
import InputSelect from "../../../../common/components/form/InputSelect.jsx";

const CustomUUID = `CUSTOM-${guid()}`;

const PreparedOptions = [
    { t_text: "CustomOption", value: CustomUUID },

    { t_text: "Capacity" },
    { t_text: "Color" },
    { t_text: "Dimensions" },
    { t_text: "Manufacturer" },
    { t_text: "Material" },
    { t_text: "Model" },
    { t_text: "Origin" },
    { t_text: "PowerConsumption" },
    { t_text: "PowerType" },
    { t_text: "QuantityInPackage" },
    { t_text: "Size" },
    { t_text: "Speed" },
    { t_text: "TemperatureRange" },
    { t_text: "Type" },
    { t_text: "Voltage" },
    { t_text: "Volume" },
    { t_text: "Warranty" },
    { t_text: "Weight" },
];

export default function ProductOptions(props) {
    const { t } = useTranslation();

    const {
        set,
        variables,
        variables: { ProductOptions },
    } = props;

    let _ProductOptions = ProductOptions || [];

    const _PreparedOptions = PreparedOptions.sort(({ t_text: a, value }, { t_text: b }) => {
        a = t(a);
        b = t(b);
        return value === CustomUUID ? -1 : a === b ? 0 : a > b ? 1 : -1;
    }).map(o => ({ ...o, t: t(o.t_text) }));

    const [optionType, setOptionType] = React.useState({ type: "select", value: "" });

    function onOptionTypeChange(value, evType) {
        if (value === CustomUUID || optionType.type === "custom") {
            setOptionType({ ...optionType, type: "custom", value: evType === "input" ? value : "" });
        } else {
            const name = t(_PreparedOptions.filter(({ t_text }) => t_text === value)?.[0]?.t_text);
            _ProductOptions = [{ name, options: [] }, ..._ProductOptions];
            setOptionType({ type: "select", value: "" });
        }

        set({ ...variables, ProductOptions: [..._ProductOptions] });
    }

    function onOptionTypeAddClick() {
        _ProductOptions = [{ name: optionType.value, options: [] }, ..._ProductOptions];
        set({ ...variables, ProductOptions: [..._ProductOptions] });
        setOptionType({ type: "select", value: "" });
    }

    function addOptionValue(group, value) {
        console.log({ group, value });
        console.log(group.options);
        group.options = [{ name: value }, ...group.options];
        set({ ...variables, ProductOptions: [..._ProductOptions] });
    }

    function delGroup(group) {
        _ProductOptions = _ProductOptions.filter(_group => _group !== group);
        set({ ...variables, ProductOptions: [..._ProductOptions] });
    }

    function delOption(group, option) {
        group.options = group.options.filter(_option => _option !== option);
        set({ ...variables, ProductOptions: [..._ProductOptions] });
    }

    return (
        <div className="grid-gap-20 align-content-start">
            <div className="text-left">
                <h3>{t("Set Your Product Options")}:</h3>
                {t("Here you can add options for your product, like size, color, etc.")}
            </div>

            <div
                className="grid-gap-20 align-items-center"
                style={{ gridTemplateColumns: optionType.type === "custom" ? "1fr max-content" : null }}
            >
                {optionType.type === "select" && (
                    <div>
                        <InputSelect
                            ket={JSON.stringify(ProductOptions)}
                            onSelect={onOptionTypeChange}
                            options={_PreparedOptions
                                .filter(({ t_text }) => {
                                    return _ProductOptions.filter(({ name }) => name === t(t_text)).length === 0;
                                })
                                .map(({ t_text, value }) => ({
                                    text: t(t_text),
                                    value: value || t_text,
                                }))}
                            selected={optionType.value}
                            placeholder={t("Option type")}
                            fullWidth
                            filterField
                        />
                    </div>
                )}

                {optionType.type === "custom" && (
                    <InputAutoresize
                        onChange={event => onOptionTypeChange(event.target.value, "input")}
                        onBlur={event => onOptionTypeChange(event.target.value, "input")}
                        value={optionType.value}
                        placeholder={t("Option type")}
                        fullWidth
                        small
                    />
                )}

                {optionType.type === "custom" && (
                    <ButtonBase
                        onClick={() => onOptionTypeAddClick()}
                        small
                        disabled={optionType.type === "custom" && !optionType.value}
                    >
                        {t("PlusAdd")}
                    </ButtonBase>
                )}
            </div>

            {_ProductOptions.length > 0 && (
                <div className="grid-gap-10">
                    {_ProductOptions.map((group, index) => (
                        <React.Fragment key={index}>
                            <div className="separator"></div>

                            <div className="grid-gap-10">
                                <div
                                    className="grid-gap-10 justify-items-start align-items-center"
                                    style={{ gridTemplateColumns: "1fr max-content" }}
                                >
                                    <p className="fw-bold">{group.name}</p>
                                    <ButtonIconTrash onClick={delGroup.bind(null, group)} small noBorder />
                                </div>

                                <div
                                    className="grid-gap-10 align-items-center"
                                    style={{ gridTemplateColumns: "1fr max-content" }}
                                >
                                    <OptionAdd add={value => addOptionValue(group, value)} />
                                </div>

                                <div className="grid-gap-10">
                                    {group.options.map((option, index2) => (
                                        <div
                                            key={`${index}-${index2}`}
                                            className="grid-gap-10 justify-items-start align-items-center"
                                            style={{ gridTemplateColumns: "1fr max-content" }}
                                        >
                                            <p>{option.name}</p>
                                            <ButtonIconTrash onClick={() => delOption(group, option)} small noBorder />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
}

function OptionAdd(props) {
    const { t } = useTranslation();
    const [value, setValue] = React.useState("");

    function _add() {
        props.add(value);
        setValue("");
    }

    return (
        <>
            <InputAutoresize
                onChange={event => setValue(event.target.value)}
                onBlur={event => setValue(event.target.value)}
                value={value}
                placeholder={t("ValueType")}
                fullWidth
                small
            />

            <ButtonBase onClick={_add} small>
                {t("PlusAdd")}
            </ButtonBase>
        </>
    );
}
